export default class RequestCache {
  constructor(cachePeriodMilliseconds) {
    this.cachePeriod = cachePeriodMilliseconds || 2 * 60 * 60 * 1000; //2 days
  }

  _isStale = item => {
    const elapsedPeriod = new Date().getTime() - item.created_on;
    return elapsedPeriod >= this.cachePeriod;
  };

  refreshCache = () => {
    sessionStorage.clear();
  };

  saveItem = (key, item, callback) => {
    let data = { payload: item, created_on: new Date().getTime() };
    try {
      // the data is saved as a string just like in localstorage
      sessionStorage.setItem(key, JSON.stringify(data));
      console.log("saved");
      callback(undefined, item);
    } catch (e) {
      callback(e);
    }
  };

  deleteItem = (key, callback) => {
    try {
      sessionStorage.removeItem(key);
      callback(undefined, true);
    } catch (error) {
      callback(error);
    }
  };

  getItem = (key, callback) => {
    try {
      const value = sessionStorage.getItem(key);
      if (value !== null) {
        // retrieve the string and convert it back to its original
        const valueObj = JSON.parse(value);
        if (this._isStale(valueObj)) {
          this.deleteItem(key, err => {
            if (!err) {
              callback(new Error("Item no longer exists."));
            } else {
              callback(new Error("Error updating the cache in the store"));
            }
          });
        } else {
          callback(undefined, valueObj.payload);
        }
      } else {
        callback(new Error("Item does not exist"));
      }
    } catch (error) {
      callback(error);
      // Error retrieving data
    }
  };
}
